/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import React, { useEffect, useState } from 'react';
import { LoadingSpinner } from '../../../loadingSpinner/loadingspinner';
import { useGetAgentsSearchQuery, useGetClientsByConfigQuery, useGetCountriesByConfigQuery, useGetGlLocationsByConfigQuery, useGetParentClientsByConfigQuery, useGetProgramsByConfigQuery, useGetProjectsByConfigQuery } from './agentFilterSlice';
import { COACHING_INSIGHTS_CONFIG } from '../../../../constants';


type agentFilterProps = {
    selectedAssociate: (value: any[]) => void;
    selectedDateRange: (value: Date[]) => void;
};

export const AgentFilter = ({
    selectedDateRange,
    selectedAssociate,
}: agentFilterProps) => {
    const [programFilter, setProgramFilter] = useState<any>([]);
    const [projectFilter, setProjectFilter] = useState<any>([]);
    const [siteFilter, setSiteFilter] = useState<any>([]);
    const [countryFilter, setCountryFilter] = useState<any>([]);
    const [clientFilter, setClientFilter] = useState<any>([]);
    const [parentClientFilter, setParentClientFilter] = useState<any>([]);
    const [selectedParentClient, setSelectedParentClient] = useState<number | null>(null);
    const [selectedClient, setSelectedClient] = useState<number | null>(null);
    const [selectedProgram, setSelectedProgram] = useState<number | null>(null);
    const [selectedProject, setSelectedProject] = useState<number | null>(null);
    const [selectedCountry, setSelectedCountry] = useState<number | null>(null);
    const [selectedSite, setSelectedSite] = useState<number | null>(null);
    const [inputParentClientId, setInputParentClientId] = useState<number | string>('');
    const [inputClientId, setInputClientId] = useState<number | string>('');
    const [inputProgramId, setInputProgramId] = useState<number | string>('');
    const [inputProjectId, setInputProjectId] = useState<number | string>('');
    const [inputCountryId, setInputCountryId] = useState<number | string>('');
    const [inputSiteId, setInputSiteId] = useState<number | string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedDate, setSelectedDate] = useState<string>('lastMonth');
    const [agents, setAgents] = useState<any>([]);
    const [inputAgents, selectedInputAgents] = useState<any>([]);
    const [resetClicked, setResetClicked] = useState<boolean>(true);
    const { data: parentClientFilterData, isFetching: parentClientFetching } = useGetParentClientsByConfigQuery({
        clientId: inputClientId,
        programId: inputProgramId,
        projectId: inputProjectId,
        countryId: inputCountryId,
        geolocationId: inputSiteId,
        configCode: COACHING_INSIGHTS_CONFIG,
        reset: resetClicked
    }, 
    // { skip: !resetClicked }
);

    const { data: clientFilterData, isFetching: clientFetching } = useGetClientsByConfigQuery({
        parentClientId: inputParentClientId,
        programId: inputProgramId,
        projectId: inputProjectId,
        countryId: inputCountryId,
        geolocationId: inputSiteId,
        configCode: COACHING_INSIGHTS_CONFIG,
        reset: resetClicked
    }, 
    // { skip: !resetClicked }
);

    const { data: programFilterData, isFetching: programFetching } = useGetProgramsByConfigQuery({
        parentClientId: inputParentClientId,
        clientId: inputClientId,
        projectId: inputProjectId,
        countryId: inputCountryId,
        geolocationId: inputSiteId,
        configCode: COACHING_INSIGHTS_CONFIG,
        reset: resetClicked
    }, 
    // { skip: !resetClicked }
);

    const { data: projectFilterData, isFetching: projectFetching } = useGetProjectsByConfigQuery({
        parentClientId: inputParentClientId,
        clientId: inputClientId,
        programId: inputProgramId,
        countryId: inputCountryId,
        geolocationId: inputSiteId,
        configCode: COACHING_INSIGHTS_CONFIG,
        reset: resetClicked
    }, 
    // { skip: !resetClicked }
);

    const { data: countryFilterData, isFetching: countryFetching } = useGetCountriesByConfigQuery({
        parentClientId: inputParentClientId,
        clientId: inputClientId,
        programId: inputProgramId,
        projectId: inputProjectId,
        geolocationId: inputSiteId,
        configCode: COACHING_INSIGHTS_CONFIG,
        reset: resetClicked
    }, 
    // { skip: !resetClicked }
);

    const { data: siteFilterData, isFetching: siteFetching } = useGetGlLocationsByConfigQuery({
        parentClientId: inputParentClientId,
        clientId: inputClientId,
        programId: inputProgramId,
        projectId: inputProjectId,
        countryId: inputCountryId,
        configCode: COACHING_INSIGHTS_CONFIG,
        reset: resetClicked
    }, 
    // { skip: !resetClicked }
);
    const { data: agentsData, isFetching: agentsFetching } = useGetAgentsSearchQuery({
        parentClientId: inputParentClientId,
        clientId: inputClientId,
        programId: inputProgramId,
        projectId: inputProjectId,
        countryId: inputCountryId,
        geolocationId: inputSiteId,

    },
        {
            skip: !inputParentClientId && !inputClientId && !inputProgramId && !inputProjectId && !inputCountryId && !inputSiteId,
        });
    useEffect(() => {
        if (parentClientFilterData?.data.length > 0) {
            setParentClientFilter(parentClientFilterData?.data);
        }
        else {
            setParentClientFilter([]);
            setSelectedParentClient(null);
            setInputParentClientId('');
        }
    }, [parentClientFilterData]);

    useEffect(() => {
        if (clientFilterData?.data.length > 0) {
            setClientFilter(clientFilterData?.data);
        }
        else {
            setClientFilter([]);
            setSelectedClient(null);
            setInputClientId('');
        }
    }, [clientFilterData]);

    useEffect(() => {
        if (programFilterData?.data.length > 0) {
            setProgramFilter(programFilterData?.data);
        }
        else {
            setProgramFilter([]);
            setSelectedProgram(null);
            setInputProgramId('');
        }

    }, [programFilterData]);

    useEffect(() => {
        if (projectFilterData?.data.length > 0) {
            setProjectFilter(projectFilterData?.data);
        }
        else {
            setProjectFilter([]);
            setSelectedProject(null);
            setInputProjectId('');
        }
    }, [projectFilterData]);

    useEffect(() => {
        if (countryFilterData?.data.length > 0) {
            setCountryFilter(countryFilterData?.data);
        }
        else {
            setCountryFilter([]);
            setSelectedCountry(null);
            setInputCountryId('');
        }
    }, [countryFilterData]);

    useEffect(() => {
        if (siteFilterData?.data.length > 0) {
            setSiteFilter(siteFilterData?.data);
        }
        else {
            setSiteFilter([]);
            setSelectedSite(null);
            setInputSiteId('');
        }
    }, [siteFilterData]);
    useEffect(() => {
        if (agentsData?.data.length > 0) {
            setAgents(agentsData?.data);
        }
        else {
            setAgents([]);
            selectedInputAgents(null);
        }
    }, [agentsData]);

    useEffect(() => {
        if (
            parentClientFetching ||
            clientFetching ||
            programFetching ||
            projectFetching ||
            countryFetching ||
            siteFetching ||
            agentsFetching
        ) {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [
        parentClientFetching,
        clientFetching,
        programFetching,
        projectFetching,
        countryFetching,
        siteFetching,
        agentsFetching
    ]);
    const resetAllFilters = () => {
        setResetClicked(!resetClicked);
        setParentClientFilter([]);
        setSelectedParentClient(null);
        setInputParentClientId('');

        setClientFilter([]);
        setSelectedClient(null);
        setInputClientId('');

        setProgramFilter([]);
        setSelectedProgram(null);
        setInputProgramId('');

        setProjectFilter([]);
        setSelectedProject(null);
        setInputProjectId('');

        setCountryFilter([]);
        setSelectedCountry(null);
        setInputCountryId('');

        setSiteFilter([]);
        setSelectedSite(null);
        setInputSiteId('');

        setAgents([]);
        selectedInputAgents(null);
        setSelectedDate('lastMonth');
        selectedAssociate([]);
    };



    const onParentClientChange = (e: { value: any }) => {
        setSelectedParentClient(e.value);
        setInputParentClientId(e.value);
    };

    const onClientChange = (e: { value: any }) => {
        setSelectedClient(e.value);
        setInputClientId(e.value);
    };

    const onProgramChange = (e: { value: any }) => {
        setSelectedProgram(e.value);
        setInputProgramId(e.value);
    };

    const onProjectChange = (e: { value: any }) => {
        setSelectedProject(e.value);
        setInputProjectId(e.value);
    };

    const onCountryChange = (e: { value: any }) => {
        setSelectedCountry(e.value);
        setInputCountryId(e.value);
    };

    const onSiteChange = (e: any) => {
        setSelectedSite(e.value);
        setInputSiteId(e.value);
    };
    const onAgentsChange = (e: any) => {
        selectedInputAgents(e.value);
    };
    const rangeOptions = [
        { label: 'Last Week', value: 'lastWeek' },
        { label: 'Last Two Weeks', value: 'last2Weeks' },
        { label: 'Last Month', value: 'lastMonth' },
        { label: 'Last Six Months', value: 'last6Months' },
        { label: 'Last Year', value: 'lastYear' },
    ];
    const handleRangeChange = (e: any) => {
        const value = e.value;
        setSelectedDate(value);
    };
    const selectedDateTemplate = (option: any) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <i className="pi pi-calendar mr-2" style={{ paddingRight: '5px' }} />
                    {option.label}
                </div>
            );
        }
        return null;
    };
    const handleSearchClick = () => {
        const calculatedDate = calculateDate(selectedDate);
        selectedDateRange(calculatedDate);
        selectedAssociate(inputAgents);
    };
    const calculateDate = (value: string): Date[] => {
        const currentDate = new Date();
        let calculatedDate = new Date();
        switch (value) {
            case 'lastWeek':
                calculatedDate.setDate(currentDate.getDate() - 7);
                break;
            case 'last2Weeks':
                calculatedDate.setDate(currentDate.getDate() - 14);
                break;
            case 'lastMonth':
                calculatedDate.setMonth(currentDate.getMonth() - 1);
                break;
            case 'last6Months':
                calculatedDate.setMonth(currentDate.getMonth() - 6);
                break;
            case 'lastYear':
                calculatedDate.setFullYear(currentDate.getFullYear() - 1);
                break;
            default:
                calculatedDate = currentDate;
                break;
        }
        return [calculatedDate, currentDate];
    };
    return (
        <>
            <div className="row mt-4">
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="parentClient">Parent Client</label>
                        <Dropdown
                            id="parentClient"
                            filter
                            placeholder="Select"
                            className="custom-dropdown"
                            value={selectedParentClient}
                            options={parentClientFilter}
                            onChange={onParentClientChange}
                            optionLabel={'parent_client_name'}
                            optionValue={'parent_client_id'}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="client">Client</label>
                        <Dropdown
                            id="client"
                            filter
                            placeholder="Select"
                            className="custom-dropdown"
                            value={selectedClient}
                            options={clientFilter}
                            onChange={onClientChange}
                            optionLabel={'client_name'}
                            optionValue={'client_id'} />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="program">Program</label>
                        <Dropdown
                            id="program"
                            filter
                            placeholder="Select"
                            className="custom-dropdown"
                            value={selectedProgram}
                            options={programFilter}
                            onChange={onProgramChange}
                            optionLabel={'program_name'}
                            optionValue={'program_id'} />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="project">Project</label>
                        <Dropdown
                            id="project"
                            filter
                            placeholder="Select"
                            className="custom-dropdown"
                            value={selectedProject}
                            options={projectFilter}
                            onChange={onProjectChange}
                            optionLabel={'project_name'}
                            optionValue={'project_id'} />
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="country">Country</label>
                        <Dropdown
                            id="country"
                            filter
                            placeholder="Select"
                            className="custom-dropdown"
                            value={selectedCountry}
                            options={countryFilter}
                            onChange={onCountryChange}
                            optionLabel={'country_name'}
                            optionValue={'country_id'} />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="site">Site</label>
                        <Dropdown
                            id="site"
                            filter
                            placeholder="Select"
                            className="custom-dropdown"
                            value={selectedSite}
                            options={siteFilter}
                            onChange={onSiteChange}
                            optionLabel={'gl_location_name'}
                            optionValue={'gl_location_id'} />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="AgentSelection">Select Associate</label>
                        <MultiSelect
                            id="AssociateSelection"
                            filter
                            placeholder="Select"
                            className="custom-dropdown"
                            value={inputAgents}
                            maxSelectedLabels={3}
                            options={agents}
                            onChange={onAgentsChange}
                            optionLabel={'employee_name'}
                            optionValue={'employee_number'} />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="date">Date Range</label>
                        <Dropdown
                            className="custom-dropdown"
                            value={selectedDate}
                            options={rangeOptions}
                            onChange={handleRangeChange}
                            placeholder="Select Range"
                            valueTemplate={selectedDateTemplate}
                            optionLabel="label"
                            optionValue="value"
                        />
                    </div>
                </div>
            </div>
            <span>{loading ? <LoadingSpinner /> : ''}</span>
            <div className="mt-4 d-flex justify-content-end gap-2">
                <Button
                    label="Search"
                    // style={{
                    //     fontWeight: 400,
                    // }}
                    disabled={!(inputAgents?.length > 0)}
                    className="btn-primary mb-2"
                    onClick={handleSearchClick}
                />
                <Button
                    label="Reset"
                    // style={{
                    //     fontWeight: 400,
                    // }}
                    disabled={selectedParentClient === null && selectedClient === null && selectedProgram === null && selectedProject === null && selectedCountry === null && selectedSite === null}
                    className="btn-secondary mb-2"
                    onClick={resetAllFilters}
                />
            </div>
        </>
    );
};
